// @flow
import routes from "./app/routes";
import configureStore from "./store/configureStore";
import { Map } from "immutable";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "ric";
// Tailwind CSS for PropertyTools is now injected inside Shadow DOM (ShadowCalculator.js)
// so it doesn't leak into the rest of the app.
import { ToastProvider } from "./app/components/ToastMessage/ToastManager";

const store = configureStore(Map());

const App = () => {
  return (
    <Provider store={store}>
      <Router>
       <ToastProvider>
       <div id="tooltip-root">
        {routes}
       </div>
       </ToastProvider>
      </Router>
    </Provider>
  );
};

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<App />);
